/* Swap Rivo's default icons inside #rivo-lp-my-rewards .rivo-card-icon with
   the brand PNG badges (the same artwork used by the "ready to cash in?"
   section below): $5/$10/$20 badges by amount, the candle badge for any
   candle reward (replaces their product photo too), and the ticket badge
   for any other reward. Product images on non-candle cards are left
   untouched so their photo continues to show in the circle. */
(function () {
  if (window.__literieRivoRewards) return;
  window.__literieRivoRewards = true;

  var BADGES = window.LITERIE_RIVO_BADGES || {};

  function badgeFor(title, hasProductImage) {
    // Any candle reward gets the candle badge — titles vary ("2.5oz free
    // candle", "free bodega bouquets (little) candle - vip reward", ...).
    if (title.indexOf('candle') !== -1) {
      return { src: BADGES.candle, alt: 'free candle' };
    }
    if (hasProductImage) return null;
    var match = title.match(/\$\s*(\d+)\s*off/);
    if (match && BADGES[match[1]]) {
      return { src: BADGES[match[1]], alt: '$' + match[1] + ' off' };
    }
    return { src: BADGES.reward, alt: 'reward' };
  }

  function applyBadge(card) {
    var iconEl = card.querySelector('.rivo-card-icon');
    var titleEl = card.querySelector('.rivo-card-title');
    if (!iconEl || !titleEl) return;
    if (iconEl.dataset.literieBadgeApplied === '1') return;

    var title = titleEl.textContent.trim().toLowerCase();
    var hasProductImage = !!iconEl.querySelector('img:not(.literie-rivo-card-badge)');
    var badge = badgeFor(title, hasProductImage);
    if (!badge || !badge.src) {
      iconEl.dataset.literieBadgeApplied = '1';
      return;
    }

    var img = document.createElement('img');
    img.src = badge.src;
    img.alt = badge.alt;
    img.loading = 'lazy';
    img.className = 'literie-rivo-card-badge';
    iconEl.innerHTML = '';
    iconEl.appendChild(img);
    iconEl.dataset.literieBadgeApplied = '1';
  }

  function scan() {
    var cards = document.querySelectorAll('#rivo-lp-my-rewards .rivo-card');
    cards.forEach(applyBadge);
  }

  function bind() {
    var section = document.querySelector('#rivo-lp-my-rewards');
    if (!section) return false;
    scan();
    new MutationObserver(scan).observe(section, { childList: true, subtree: true });
    return true;
  }

  function init() {
    if (bind()) return;
    // Rivo lazy-mounts the rewards block — poll briefly until it appears.
    var attempts = 0;
    var poll = setInterval(function () {
      if (bind() || ++attempts > 60) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
